import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'


export class SelectPaymentMethodRequest {
  url: URL
  body: FormData
  method = 'POST' as const

  constructor(url: URL, paymentMethod: string) {
    const formData: FormData = new FormData()
    formData.append('payment_method', paymentMethod)

    this.url = url
    this.body = formData
  }
}


export const SELECT_PAYMENT_METHOD_API = Symbol('SELECT_PAYMENT_METHOD_API')


export interface SelectPaymentMethodApi {
  selectPaymentMethod(request: SelectPaymentMethodRequest): Promise<void>
}


@registerDependency(FAKE, SELECT_PAYMENT_METHOD_API)
export class FakeSelectPaymentMethodApi implements SelectPaymentMethodApi {
  requests: SelectPaymentMethodRequest[] = []

  async selectPaymentMethod(request: SelectPaymentMethodRequest): Promise<void> {
    this.requests.push(request)
  }

  assertSelectedPaymentMethodRequestReceived(expected: SelectPaymentMethodRequest): void {
    const filtered = this.requests.map(this.parseSelectPaymentMethodRequest)

    const expectedRequest = this.parseSelectPaymentMethodRequest(expected)
    const containsRequest = filtered.find((request: object) => JSON.stringify(request) === JSON.stringify(expectedRequest))

    if (containsRequest === undefined) {
      throw new Error(`Expected request ${JSON.stringify(expectedRequest, null, '\t')} not found in ${JSON.stringify(filtered, null, '\t')}`)
    }
  }

  private parseSelectPaymentMethodRequest(request: SelectPaymentMethodRequest): object {
    const body: any = {}
    request.body.forEach((value: FormDataEntryValue, key: string) => body[key] = value)
    return {
      url: request.url,
      method: request.method,
      body: body
    }
  }
}


@registerDependency(REAL, SELECT_PAYMENT_METHOD_API)
export class RealSelectPaymentMethodApi implements SelectPaymentMethodApi {
  async selectPaymentMethod(request: SelectPaymentMethodRequest): Promise<void> {
    await fetch(request.url, { method: request.method, body: request.body })
  }
}
